import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import { Icon24Edit, Icon48Jobs, Icon24Celebrate } from '@care/react-embrace-icons';

export const JobHowItWorks = () => {
  const stats = [
    {
      Icon: Icon24Edit,
      primaryText: `Sign up`,
      secondaryText: `Create a profile to find jobs that fit your schedule`,
    },
    {
      Icon: Icon48Jobs,
      primaryText: `Search for jobs`,
      secondaryText: `Apply to jobs posted by local families hiring in your area`,
    },
    {
      Icon: Icon24Celebrate,
      primaryText: `Get hired`,
      secondaryText: `Match with families, take jobs as you need them, and start earning!`,
    },
  ];
  return (
    <Box py={{ xs: 6, sm: 0 }} mt={{ xs: 0, md: 3 }} ml={{ xs: 3, sm: 0, md: 0 }}>
      <Typography variant="h2">How it works</Typography>
      <List
        sx={{
          display: { xs: 'block', sm: 'flex', md: 'block' },
          mt: 3,
          maxWidth: { xs: '327px', sm: '100%' },
        }}>
        {stats.map(({ Icon, primaryText, secondaryText }) => (
          <ListItem
            disableGutters
            sx={{
              py: 0,
              mx: 0,
              mt: { xs: 2, sm: 0, md: 2 },
              mr: { xs: undefined, sm: 4, md: undefined },
              '&:first-of-type': { mt: 0 },
            }}
            key={primaryText}>
            <ListItemAvatar sx={{ mr: { xs: 3, sm: 2, md: 3 } }}>
              <Avatar
                sx={{
                  bgcolor: 'background.accent.accent3',
                  height: '64px',
                  width: '64px',
                }}>
                <Icon size="40px" color="text.primary" />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              sx={{ flexWrap: 'wrap' }}
              primaryTypographyProps={{
                color: 'text.primary',
                variant: 'h4',
              }}
              primary={primaryText}
              secondaryTypographyProps={{
                color: 'text.secondary',
                variant: 'body3',
              }}
              secondary={secondaryText}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
